export default __webpack_public_path__ + "media/images/logo/media/nikkei-0ff8b861100f33003c219b967ee6051d.png";